var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[(_vm.show)?_c('img',{staticClass:"banner",attrs:{"src":require("../../assets/images/signResult.png"),"alt":""}}):_vm._e(),_vm._v(" "),(_vm.show)?_c('p',{staticClass:"desc"},[_vm._v("实名认证失败")]):_vm._e(),_vm._v(" "),_c('a',{attrs:{"id":"jump","href":"","target":"_blank"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f4d455e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/authResult.vue
// module id = pwhB
// module chunks = 0